import React from 'react';
import { siteConfig } from '../../config/siteConfig';
import './CallToAction.css';

const CallToAction = () => {
  const { callToAction } = siteConfig;

  const sectionStyle = {
    '--cta-background-image': `url(${callToAction.backgroundImage.src})`
  };

  return (
    <section className="call-to-action" style={sectionStyle}>
      <div className="call-to-action-content">
        <div className="cta-text">
          <h2 className="cta-title">{callToAction.title}</h2>
          <h2 className="cta-subtitle">{callToAction.subtitle}</h2>
        </div>
        <a 
          href={callToAction.buttonUrl}
          className="cta-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          {callToAction.buttonText}
        </a>
      </div>
    </section>
  );
};

export default CallToAction; 